// sections/Company.js
import React from 'react';
import './Company.css';
import mapImage from '../assets/map.png'; // 地図画像

const companyInfo = {
  name: '株式会社灯白社',
  founded: '2020年6月1日',
  capital: '¥0,000,000',
  phone: '050-3159-6205',
  address: '〒150-0031 東京都渋谷区桜丘町１６－１３ 桜丘フロントⅡビル 3F',
  mapLink: 'https://maps.app.goo.gl/JrqrpRw9BgJ4yftr5'
};

function Company() {
  return (
    <section id="company" className="company-section">
      <h2 className="section-title">COMPANY</h2>
      <div className="company-content">
        <div className="company-info-panel">
          <table>
            <tbody>
              <tr>
                <th>会社名</th>
                <td>{companyInfo.name}</td>
              </tr>
              <tr>
                <th>創業</th>
                <td>{companyInfo.founded}</td>
              </tr>
              <tr>
                <th>資本金</th>
                <td>{companyInfo.capital}</td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td>{companyInfo.phone}</td>
              </tr>
              <tr>
                <th>所在地</th>
                <td>
                  <p>{companyInfo.address}</p>
                  <a href={companyInfo.mapLink} target="_blank" rel="noopener noreferrer" className="location-button">LOCATION</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="company-map-panel">
          <img src={mapImage} alt="会社所在地地図" className="map-image" />
        </div>
      </div>
    </section>
  );
}

export default Company;